@import "src/helpers/ScreenSizes.scss"; //imports mixins for different screen sizes

.cardScreen {
  @include windowSizes();
  border: 1px solid #c5c5ca;
  border-radius: 20px;
  background-color: white;
  overflow: auto;
}

.closeButtonContainer {
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: flex-end;
  padding: 21px 21px 0 0;
  background: #ffffff;
}

.cardScreenContent {
  padding: 20px 72px 0px 72px;
  font-family: "Inter";
  font-style: normal;
  color: #39393a;

  @include medium() {
    padding: 20px 26px 0px 26px;
  }

  @include small() {
    padding: 20px 18px 0px 18px;
  }
}

.greetingText {
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
}

.cardInputDescriptionText {
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  text-align: center;
  font-feature-settings: "liga" off;
  margin: 8px 0 16px 0;
}

.horizontalMarkContainer {
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
  justify-content: center;

  margin: 0 0 16px 0;
}

.horizontalMarkContainer horizontal-mark {
  --srci-horizontal-mark-height: 16px;

  display: inline-flex;
  flex: 0 0 auto;
  flex-flow: row nowrap;
  align-items: center;
  gap: 24px;
}

.horizontalMarkText {
  margin: 0 24px 0 0;
}

.switchUserComponent {
  font-weight: 700;
  line-height: 24px;
  margin: 0 0 16px 0;
}

.switchUserComponent > switch-user {
  display: block;
}

.consumerCardScreen {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: min(677px, calc(100vh - var(--payair-payment-sheet-viewport-gap, 20px)));
  height: min(677px, calc(100dvh - var(--payair-payment-sheet-viewport-gap, 20px)));
  overflow: visible;
}

.consumerCardScreen .closeButtonContainer {
  flex: 0 0 auto;
  border-radius: 19px 19px 0 0;
}

.consumerCardScreen .cardScreenContent {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
}

.consumerCardScrollableContent {
  box-sizing: border-box;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  min-height: 0;
  min-width: 0;
  overflow: visible;
  padding: 0 2px;
}

// These components render without Shadow DOM, so their own `:host` rules are not
// a reliable sizing boundary in every distribution target. Size the host from
// its owning screen to keep the nested body genuinely scrollable.
.consumerCardScrollableContent > two-step-card-flow {
  display: flex;
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  max-height: 100%;
  min-height: 0;
  min-width: 0;
}

// The SDK-owned overlay is the single scroll owner. Embedded merchant
// containers retain the bounded, internally scrolling presentation above.
.payairPaymentSheetOverlay .consumerCardScreen {
  height: auto;
}

.payairPaymentSheetOverlay .consumerCardScreen .cardScreenContent,
.payairPaymentSheetOverlay .consumerCardScrollableContent,
.payairPaymentSheetOverlay .consumerCardScrollableContent > two-step-card-flow {
  flex: 0 0 auto;
  height: auto;
  max-height: none;
}

.consumerCardScreen .selectCardTextButton {
  margin-top: 24px;
  margin-bottom: 0;
}

@media (max-width: 540px) and (max-height: 700px) {
  .consumerCardScreen .cardScreenContent {
    padding-top: 12px;
  }

  .cardInputDescriptionText,
  .horizontalMarkContainer,
  .switchUserComponent {
    margin-bottom: 12px;
  }
}

.selectCardTextButton {
  padding: 0;
  border: 0;
  background: none;
  margin-top: 24px;
  margin-bottom: 40px;

  text-align: center;
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  font-feature-settings: "liga" off;

  color: #4d5ef2;
  cursor: pointer;
}
